import { HttpClient } from "@angular/common/http";
import { Injectable, Injector } from "@angular/core";
import { OfficeSelectorService } from "src/app/common/officeSelector/officeSelector.service";
import { KpiService } from "src/app/dashboardCommon/services/kpiService";
import { PendingOrdersFDKpiCfg, PendingOrdersFDKpiCfgService } from "./pendingOrdersFDKpiCfg.service";
import { KpiServiceError, KpiServiceErrorType } from "src/app/dashboardCommon/services/kpiServiceError";
import { ApigeeService } from "src/app/auth/apigee/apigee.service";

export class PendingOrdersFDDetailServiceDataItem{
    public pPranchId: String;
    public orderId: number;
    public requestedJob: string;
    public pendingOrderLineFDWorker: number;
    public pendingContract: number;
    public pendingWorkers: number;

    public clienteName: string;
    public ctoBegDate: Date;
}

export class PendingOrdersFDDetailServiceData{
    public pendingOrdersFD: PendingOrdersFDDetailServiceDataItem[];
    public updateTimestamp: Date;
}

@Injectable()
export class PendingOrdersFDDetailService extends KpiService <PendingOrdersFDDetailServiceData>{
    public getClassName(): string {
        return "PendingOrdersFDDetailService";
    }

    constructor(
        private serviceCfg: PendingOrdersFDKpiCfgService,
        private apigeeService: ApigeeService,
        private officeSelectorService: OfficeSelectorService,
        private httpClient: HttpClient,
        injector: Injector
    ){
        super(injector);
    }

    protected async update(): Promise<PendingOrdersFDDetailServiceData> {
        if (this.apigeeService.apiToken){
            let result: PendingOrdersFDDetailServiceData = null;
            try {
                let cfg: PendingOrdersFDKpiCfg = this.serviceCfg.getCfg();
                
                let url = cfg.pendingOrdersFD.detailEndpointPattern.format(this.officeSelectorService.selectedOffice.id);
                result = await this.httpClient.get<PendingOrdersFDDetailServiceData>(url).toPromise();
            } catch (error) {
                let errorMessage = error.error ? error.error.message || error.error.errorMessage : error.message;
                throw new KpiServiceError(KpiServiceErrorType.requestError, "KpiServiceError-{0}-{1}".format(this.getClassName(), errorMessage));
            }

            if (result == null) throw new KpiServiceError(KpiServiceErrorType.noData, "KpiServiceError-{0}-No data".format(this.getClassName()));
            else return result;
        } else {
            throw new KpiServiceError(KpiServiceErrorType.missingInputParameters, "KpiServiceError-{0}-Missing input parameters".format(this.getClassName()));
        }
    }

}